const TermsPage: React.FC = () => {
  window.location.href = 'https://snappt.com/terms-conditions/';
  return <div></div>;
};

export default TermsPage;
